var _rect, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 286 103",
    role: "img",
    "aria-label": "Shoot Connect logo",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 286,
    height: 103,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 18)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 29,
    fill: "none",
    stroke: "#ff7a00",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 10.5,
    fill: "#57b94f"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 6,
    x2: 35,
    y2: 16,
    stroke: "#ff7a00",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 54,
    x2: 35,
    y2: 64,
    stroke: "#ff7a00",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 35,
    x2: 16,
    y2: 35,
    stroke: "#ff7a00",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 35,
    x2: 64,
    y2: 35,
    stroke: "#ff7a00",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 43,
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    fontSize: 23,
    fontWeight: 600,
    fill: "#9c9c9c",
    letterSpacing: 0.4
  }, "SHOOT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 75,
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    fontSize: 44,
    fontWeight: 800,
    letterSpacing: -1
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#ffffff"
  }, "CONN"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#ff7a00"
  }, "ECT"))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.75b24195b91e1d7770fd59dcd455b064.svg";